<template>
  <van-popup
    v-model="visible"
    :style="{ height: '100%' }"
    position="bottom"
    :close-on-click-overlay="true"
    get-container="body"
  >
    <div class="search-popup">
      <!-- 搜索框 -->
      <div class="search-popup-bar">
        <div class="search-bar-inner">
          <input 
            ref="searchInput"
            type="text" 
            placeholder="搜索" 
            class="search-input-inner"
            v-model="searchKeyword"
            @keyup.enter="handleSearch"
          />
          <button class="search-btn-inner" @click="handleSearch">
          </button>
        </div>
      </div>
      <!-- 分类下拉菜单 -->
      <van-dropdown-menu>
        <van-dropdown-item 
          v-model="selectedArea" 
          :options="areaOptions"
          :title="getAreaTitle()"
          @change="handleAreaChange"
        />
        <van-dropdown-item 
          v-model="selectedNavCategory" 
          :options="navCategoryOptions"
          :title="getNavCategoryTitle()"
          @change="handleNavCategoryChange"
        />
        <van-dropdown-item 
          v-if="selectedNavCategory === '特色农产品'"
          v-model="selectedSecondCategory" 
          :options="secondCategoryOptions"
          :title="getSecondCategoryTitle()"
          @change="handleSecondCategoryChange"
        />
      </van-dropdown-menu>
      
      <!-- 搜索结果列表 -->
      <div class="search-results-container" ref="scrollContainer">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          :immediate-check="false"
          :offset="50"
        >
          <div 
            class="search-result-item"
            :class="{ 'animate-in': isFirstPage }"
            v-for="(item, index) in searchResults"
            :key="`result-${item.id}-${index}`"
            :style="isFirstPage ? { animationDelay: `${index * 0.05}s` } : {}"
            @click="handleResultClick(item)"
          >
            <div class="result-icon">
              <img :src="item.icon || perIcon" alt="" />
            </div>
            <div class="result-content">
              <div class="result-name">{{ item.name }}</div>
              <div class="result-desc" v-if="item.desc">{{ item.desc }}</div>
            </div>
          </div>
        </van-list>
      </div>
      
      <!-- 空状态 -->
      <van-empty 
        v-if="hasSearched && searchResults.length === 0 && !loading"
        description="暂无搜索结果"
        image="search"
      />
      
      <!-- 关闭按钮 -->
      <div class="close-btn" @click="handleClose">
        <img :src="goBackIcon" alt="关闭" />
      </div>
    </div>
  </van-popup>
</template>

<script>
let markerIcon = 'https://lbs-nfncb.nfncb.cn/gzmap/img/marker.png'
let perIcon = 'https://lbs-nfncb.nfncb.cn/gzmap/img/per.png'
let goBackIcon = 'https://lbs-nfncb.nfncb.cn/gzmap/img/goBack.png'

export default {
  name: 'SearchPopup',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      markerIcon: markerIcon,
      perIcon: perIcon,
      goBackIcon: goBackIcon,
      searchKeyword: '', // 搜索关键词
      selectedArea: '', // 选中的区域
      selectedNavCategory: '', // 选中的导航分类
      selectedSecondCategory: '', // 选中的二级分类
      areaOptions: [
        { text: '全部区域', value: '', code: '' },
        { text: '越秀区', value: '越秀区', code: '440104' },
        { text: '海珠区', value: '海珠区', code: '440105' },
        { text: '荔湾区', value: '荔湾区', code: '440103' },
        { text: '天河区', value: '天河区', code: '440106' },
        { text: '白云区', value: '白云区', code: '440111' },
        { text: '黄埔区', value: '黄埔区', code: '440112' },
        { text: '番禺区', value: '番禺区', code: '440113' },
        { text: '花都区', value: '花都区', code: '440114' },
        { text: '南沙区', value: '南沙区', code: '440115' },
        { text: '从化区', value: '从化区', code: '440117' },
        { text: '增城区', value: '增城区', code: '440118' }
      ],
      navCategoryOptions: [
        { text: '优品集', value: '特色农产品' },
        { text: '游乐集', value: '都市农业' },
        { text: '文化集', value: '农业文化遗产' },
        // { text: '特色农事体验和乡村非遗活动', value: '特色农事体验和乡村非遗活动' }
      ],
      secondCategoryOptions: [
        { text: '全部品类', value: '' },
        { text: '绿色蔬菜', value: '绿色蔬菜' },
        { text: '精品花卉', value: '精品花卉' },
        { text: '优质粮油', value: '优质粮油' },
        { text: '优新水果', value: '优新水果' },
        { text: '生态畜禽', value: '生态畜禽' },
        { text: '现代渔业', value: '现代渔业' },
        { text: '其他优品', value: '其他优品' },
        // { text: '马年年货', value: '马年年货' }
      ],
      searchResults: [], // 搜索结果列表
      hasSearched: false, // 是否已搜索
      currentPage: 1, // 当前页码
      loading: false, // 是否正在加载
      finished: false, // 是否已加载完
      total: 0, // 总数据量
      isFirstPage: true // 是否是第一页，用于控制动画
    }
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    value(newVal) {
      if (newVal) {
        // 打开弹窗时自动触发搜索
        this.hasSearched = true
        this.$nextTick(() => {
          this.fetchSearchResults(this.searchKeyword.trim())
        })
      }
    }
  },
  methods: {
    // 关闭弹窗
    handleClose() {
      this.searchResults = []
      this.$emit('input', false)
    },
    // 处理搜索
    handleSearch() {
      const keyword = this.searchKeyword.trim()
      this.hasSearched = true
      
      // 重置分页状态
      this.currentPage = 1
      this.searchResults = []
      this.finished = false
      
      // 调用搜索接口，传递搜索关键词和当前选中的分类
      this.fetchSearchResults(keyword, true)
    },
    // 请求搜索结果
    fetchSearchResults(keyword = '', isReset = false) {
      // 如果是重置搜索，重置分页
      if (isReset) {
        this.currentPage = 1
        this.searchResults = []
        this.finished = false
        this.isFirstPage = true
      } else {
        // 如果不是重置，说明是加载更多，不是第一页
        this.isFirstPage = false
      }
      
      this.loading = true
      // 获取区域代码
      const areaOption = this.areaOptions.find(opt => opt.value === this.selectedArea)
      const areaCode = areaOption ? areaOption.code : ''
      
      // 构建搜索参数
      const params = {}
      if (areaCode) {
        params.area_code = areaCode
      }
      // 确保分类参数被正确添加
      if (this.selectedNavCategory) {
        params.classify = this.selectedNavCategory
      }
      if (this.selectedNavCategory === '特色农产品' && this.selectedSecondCategory) {
        params.classify_second = this.selectedSecondCategory
      }
      if (keyword) {
        params.search = keyword
      }
      // 添加分页参数
      params.page = this.currentPage
      
      // 调试：输出搜索参数
      console.log('搜索参数:', {
        keyword,
        selectedNavCategory: this.selectedNavCategory,
        selectedSecondCategory: this.selectedSecondCategory,
        selectedArea: this.selectedArea,
        params
      })
      
      // 调用搜索接口
      let url = '/api/search_list'
      const queryParams = []
      
      if (params.area_code) {
        queryParams.push(`area_code=${encodeURIComponent(params.area_code)}`)
      }
      if (params.classify) {
        queryParams.push(`classify=${encodeURIComponent(params.classify)}`)
      }
      if (params.classify_second) {
        queryParams.push(`classify_second=${encodeURIComponent(params.classify_second)}`)
      }
      if (params.search) {
        queryParams.push(`search=${encodeURIComponent(params.search)}`)
      }
      // 添加分页参数
      if (params.page) {
        queryParams.push(`page=${params.page}`)
      }
      
      if (queryParams.length > 0) {
        url = `${url}?${queryParams.join('&')}`
      }
      
      this.$api.get(url)
        .then(response => {
          // 处理响应数据
          let resultData = response.data
          
          // 如果 response.data 是字符串，需要解析
          if (typeof resultData === 'string') {
            try {
              resultData = JSON.parse(resultData)
            } catch (e) {
              if (isReset) {
                this.searchResults = []
              }
              this.finished = true
              this.loading = false
              return
            }
          }
          
          // 检查响应结构 - 适配新的分页数据结构
          if (resultData && resultData.code === 200) {
            // 新的数据结构：resultData.data.data 是数组
            let data = []
            let paginationInfo = null
            
            if (resultData.data && Array.isArray(resultData.data)) {
              // 旧格式：直接是数组
              data = resultData.data
            } else if (resultData.data && resultData.data.data && Array.isArray(resultData.data.data)) {
              // 新格式：分页结构，数据在 data.data 中
              data = resultData.data.data
              paginationInfo = {
                current_page: resultData.data.current_page,
                last_page: resultData.data.last_page,
                total: resultData.data.total
              }
            }
            
            
            // 追加数据（加载更多）或替换数据（新搜索）
            const newResults = data.map(shop => ({
              id: shop.id,
              name: shop.name || '',
              desc: shop.address || shop.introduction || '',
              lat: shop.lat,
              lng: shop.lng,
              icon: shop.shop_cover || perIcon,
              classify_second: shop.classify_second || null,
              classify: shop.classify || ''
            }))
            
            if (isReset) {
              this.searchResults = newResults
            } else {
              this.searchResults = [...this.searchResults, ...newResults]
            }
            
            // 更新分页状态
            if (paginationInfo) {
              this.total = paginationInfo.total
              // 判断是否已加载完
              if (this.currentPage >= paginationInfo.last_page) {
                this.finished = true
              } else {
                this.finished = false
              }
            } else {
              // 旧格式：如果没有分页信息，根据返回数据长度判断
              if (data.length === 0) {
                this.finished = true
              } else {
                this.finished = false
              }
            }

            
            // 确保 loading 状态被重置
            this.loading = false
            
          } else {
            if (isReset) {
              this.searchResults = []
            }
            this.finished = true
            this.loading = false
          }
        })
        .catch(error => {
          console.error('搜索失败:', error)
          console.error('错误详情:', error.response || error.message)
          if (isReset) {
            this.searchResults = []
          }
          this.finished = true
          this.loading = false
        })
    },
    // 区域分类变化
    handleAreaChange(value) {
      this.selectedArea = value
      // 如果已有搜索关键词，重新搜索
      if (this.searchKeyword.trim() || this.hasSearched) {
        this.currentPage = 1
        this.searchResults = []
        this.finished = false
        this.fetchSearchResults(this.searchKeyword.trim(), true)
      }
    },
    // 导航分类变化
    handleNavCategoryChange(value) {
      this.selectedNavCategory = value
      // 如果不是特色农产品，清空二级分类
      if (value !== '特色农产品') {
        this.selectedSecondCategory = ''
      }
      // 如果已有搜索关键词，重新搜索
      if (this.searchKeyword.trim() || this.hasSearched) {
        this.currentPage = 1
        this.searchResults = []
        this.finished = false
        this.fetchSearchResults(this.searchKeyword.trim(), true)
      }
    },
    // 二级分类变化
    handleSecondCategoryChange(value) {
      this.selectedSecondCategory = value
      // 如果已有搜索关键词，重新搜索
      if (this.searchKeyword.trim() || this.hasSearched) {
        this.currentPage = 1
        this.searchResults = []
        this.finished = false
        this.fetchSearchResults(this.searchKeyword.trim(), true)
      }
    },
    // 获取区域分类标题
    getAreaTitle() {
      if (!this.selectedArea) {
        return '所属县区'
      }
      const option = this.areaOptions.find(opt => opt.value === this.selectedArea)
      return option ? option.text : '所属县区'
    },
    // 获取导航分类标题
    getNavCategoryTitle() {
      if (!this.selectedNavCategory) {
        return '分类'
      }
      const option = this.navCategoryOptions.find(opt => opt.value === this.selectedNavCategory)
      return option ? option.text : '分类'
    },
    // 获取二级分类标题
    getSecondCategoryTitle() {
      if (!this.selectedSecondCategory) {
        return '品类'
      }
      const option = this.secondCategoryOptions.find(opt => opt.value === this.selectedSecondCategory)
      return option ? option.text : '品类'
    },
    // 点击搜索结果项
    handleResultClick(item) {
      this.$emit('result-click', item)
      this.handleClose()
    },
    // 下拉加载更多
    onLoad() {

      
      if (this.finished) {
        this.loading = false
        return
      }
      
     
      
      this.currentPage++
      this.fetchSearchResults(this.searchKeyword.trim(), false)
    }
  }
}
</script>

<style scoped>
/* 搜索弹窗样式 */
.search-popup {
  height: 100%;
  width: 10rem;
  display: flex;
  flex-direction: column;
  background-color: #fff;
}

.search-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
}

.search-header-left {
  width: 40px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.search-header-title {
  flex: 1;
  text-align: center;
  font-size: 32px;
  font-weight: 500;
  color: #333;
}

.search-header-right {
  width: 40px;
}

.search-popup-bar {
  padding: 24px 20px 0;
  background-color: #fff;
}

.search-bar-inner {
  display: flex;
  align-items: center;
  background-color: #ffffff;
  border-radius: 50px;
  border: 1px solid #e0e0e0;
  padding: 8px 12px;
  margin: 8px 16px;
}

.search-input-inner {
  flex: 1;
  border: none;
  outline: none;
  font-size: 28px;
  color: #333;
  padding: 8px 12px;
  background: transparent;
}

.search-input-inner::placeholder {
  color: #999;
}

.search-btn-inner {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: none;
  background: url("https://lbs-nfncb.nfncb.cn/gzmap/img/search.png") no-repeat center center;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.2s;
}

.search-btn-inner:active {
  transform: scale(0.95);
}

/* 搜索结果容器 */
.search-results-container {
  flex: 1;
  overflow-y: auto;
  padding: 16px 20px;
  height: 0; /* 重要：让 flex 子元素正确计算高度 */
}

/* van-list 容器样式 */
:deep(.van-list) {
  min-height: 100%;
}

:deep(.van-list__finished-text),
:deep(.van-list__loading) {
  padding: 16px 0;
  text-align: center;
  color: #969799;
  font-size: 28px;
}

.search-result-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 20px 0;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background-color 0.2s;
}

.search-result-item.animate-in {
  animation: slideInFromRight 0.4s ease-out forwards;
  opacity: 0;
}

.search-result-item:active {
  background-color: #f5f5f5;
}

.search-result-item:last-child {
  border-bottom: none;
}

.result-icon {
  width: 80px;
  height: 80px;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;
  background-color: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.result-icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.result-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.result-name {
  font-size: 30px;
  font-weight: 500;
  color: #333;
  line-height: 1.4;
}

.result-desc {
  font-size: 24px;
  color: #999;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

/* 从右到左进入动画 */
@keyframes slideInFromRight {
  from {
    opacity: 0;
    transform: translateX(100px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* 关闭按钮 */
.close-btn {
  position: fixed;
  right: 10px;
  bottom: 120px;
  width: 112px; 
  height: 112px; 
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 2001;
  transition: transform 0.2s;
}

.close-btn:active {
  transform: scale(0.9);
}

.close-btn img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>

